  document.addEventListener('DOMContentLoaded', function () {
    $('.slickslider-cutritionist').slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
    });

    $('.Testimonials-Slider').slick({
      centerMode: false,
      // centerPadding: '160px',
      slidesToShow: 4,
      infinite: false,
      prevArrow:
        '<div class="arrowsec prev-arrowsec"><img src="https://innovist.com/cdn/shop/files/right-arroe.png?v=1708350033" loading="lazy" /></div>',
      nextArrow:
        '<div class="arrowsec next-arrowsec"><img src="https://innovist.com/cdn/shop/files/right-arroe.png?v=1708350033" loading="lazy" /></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
          },
        },
      ],
    });

    $('.Trust-Slider').slick({
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:
        '<div class="arrowsec prev-arrowsec"><img src="https://innovist.com/cdn/shop/files/right-arroe.png?v=1708350033" loading="lazy" /></div>',
      nextArrow:
        '<div class="arrowsec next-arrowsec"><img src="https://innovist.com/cdn/shop/files/right-arroe.png?v=1708350033" loading="lazy" /></div>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },

        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

    $('.cardslider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev">Previous</button>',
      nextArrow: '<button type="button" class="slick-next">Next</button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $('.readmoretext span').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.hiddensec').removeClass('active');
        $(this).text('Read More');
      } else {
        $(this).addClass('active');
        $('.hiddensec').addClass('active');
        $(this).text('Read Less');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    if ($(window).width() >= 768) {
      $('.testimonial-tagss').slick({
        dots: false,
        arrows: false,
        infinite: false,

        slidesToShow: 2,
        slidesToScroll: 1,

        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,

              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });
    }

    $('.testimonial-tag').click(function () {
      $('.testimonial-tag').removeClass('active');
      $(this).addClass('active');

      var index = $(this).index() + 1;
      $('.testimonial-content').removeClass('active');
      $('.testimonial-content' + index).addClass('active');
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    $('.swiper-wrapperefvedc_neww').slick({
      dots: false,
      arrows: true,
      prevArrow: $('.leftff'),
      nextArrow: $('.rightt'),
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    $('.bnbibiguiguigu').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            centerMode: true,
            centerPadding: '20px',
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '20px',
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    $('.swiper-wrapperefvedc_newwppp').slick({
      dots: true,
      arrows: false,

      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    $('.cardslider_newppp').slick({
      dots: false,
      infinite: false,
      speed: 300,
      prevArrow: $('.left_bs'),
      nextArrow: $('.right_bs'),
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    $('.swiper-wrappedvdvdvvdrpr').slick({
      dots: true,
      infinite: false,
      speed: 300,
      prevArrow: $('.left_bss'),
      nextArrow: $('.right_bss'),
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    $('.swiper-wrapperefvedc_new').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            centerMode: true,
            centerPadding: '20px',
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '20px',
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    if ($(window).width() < 767) {
      $('.percentage-right-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
      });
    }
  });
        document.addEventListener('DOMContentLoaded', function () {
          $('.swiper-wrapperefvedc_newe').slick({
            dots: true,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                  dots: true,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  centerMode: true,
                  centerPadding: '20px',
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '20px',
                },
              },
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
            ],
          });
        });
